import { MappedClass, MappedProperty, MappedPropertyOptional } from '@h5s/util-object';
import { Department } from '../../settings/entities';
import { ZPrinterMeanType } from './z-printer-mean-type';

@MappedClass()
export class ZPrinterFiscalConfigDepartmentIn {
  @MappedProperty()
  index: number;

  @MappedProperty()
  vat_index: number;

  @MappedProperty()
  name: string;

  @MappedProperty()
  type: ZPrinterMeanType;

  // Campi non gestiti da questa configurazione: restano undefined e vengono omessi dal payload
  @MappedPropertyOptional()
  halo: number | undefined;

  @MappedPropertyOptional()
  lalo: number | undefined;

  @MappedPropertyOptional()
  single: boolean | undefined;

  @MappedPropertyOptional()
  group_code: number | undefined;

  @MappedPropertyOptional()
  default_amount: number | undefined;

  @MappedProperty()
  ateco_index: number;

  public fromDepartment(department: Department, vatIndexById: Map<number, number>): void {
    // sendFiscalConfig() blocca l'invio prima di arrivare qui se manca cashRegisterCode; se il valore
    // presente non è comunque un numero valido, meglio fallire in modo esplicito che mandare un index
    // NaN/inventato a una stampante fiscale reale (stessa filosofia di ZPrinterFiscalConfigVatIn)
    const index = parseInt(department.cashRegisterCode ?? '');
    if (Number.isNaN(index)) {
      throw new Error(
        `[ZPrinterFiscalConfigDepartmentIn] Codice registratore di cassa non numerico per il reparto '${department.description}': '${department.cashRegisterCode}'`,
      );
    }
    this.index = index;

    const vatIndex = vatIndexById.get(department.vatRateId);
    if (vatIndex === undefined) {
      throw new Error(
        `[ZPrinterFiscalConfigDepartmentIn] Nessun indice IVA calcolato per il reparto '${department.description}' (vatRateId: ${department.vatRateId})`,
      );
    }
    this.vat_index = vatIndex;

    this.name = department.description;
    this.type = department.sellGoods ? ZPrinterMeanType.Good : ZPrinterMeanType.Service;

    // Il codice ATECO è facoltativo (0 = nessuno), ma se è valorizzato deve essere numerico:
    // stessa guardia esplicita usata sopra per index e vat_index
    const atecoCode = department.atecoCode?.cashRegisterCode;
    if (!atecoCode) {
      this.ateco_index = 0;
      return;
    }

    const atecoIndex = parseInt(atecoCode);
    if (Number.isNaN(atecoIndex)) {
      throw new Error(
        `[ZPrinterFiscalConfigDepartmentIn] Codice ATECO non numerico per il reparto '${department.description}': '${atecoCode}'`,
      );
    }
    this.ateco_index = atecoIndex;
  }
}
